'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Module;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('./');

var modules = _interopRequireWildcard(_);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Headline from './Headline';
//import RichText from './RichText';
//import HalfRichText from './HalfRichText';
//import Image from './Image';
//import Embed from './Embed';

var CLASS_NAME = 'module';

var getModuleComponent = function getModuleComponent(type) {
  return modules[type];
};

function Module(props) {
  var type = props.type;


  var ModuleType = getModuleComponent(type);

  if (ModuleType) {
    return _react2.default.createElement(
      'div',
      { className: CLASS_NAME },
      _react2.default.createElement(ModuleType, (0, _extends3.default)({
        moduleClass: 'module'
      }, props))
    );
  }

  return _react2.default.createElement('div', {
    className: 'module-not-found-' + type
  });
}

Module.propTypes = {
  title: _react.PropTypes.any,
  type: _react.PropTypes.string.isRequired
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Module.jsx
// module id = 1248
// module chunks = 0